import {commitMutation, graphql} from 'react-relay';
import type {Environment, Disposable} from 'relay-runtime';
import {csrfToken, socketClientId} from '../../../forecast-app/ticketing/graphql/forecastRelay';
import type {
	useUpdateTicketingNotificationPrefsMutation,
	UpdateTicketingNotificationPrefsInput,
} from './__generated__/useUpdateTicketingNotificationPrefsMutation.graphql';

const mutation = graphql`
	mutation useUpdateTicketingNotificationPrefsMutation($input: UpdateTicketingNotificationPrefsInput!) {
		updateTicketingNotificationPrefs(input: $input) {
			clientMutationId
			user {
				id
				notificationPrefs {
					emailAssigned
					emailMentioned
					emailCustomerReplied
					emailWatching
					inAppAssigned
					inAppMentioned
					inAppCustomerReplied
					inAppWatching
				}
			}
		}
	}
`;

function commit(
	environment: Environment,
	input: UpdateTicketingNotificationPrefsInput,
	onCompleted?: (r: useUpdateTicketingNotificationPrefsMutation['response']) => void,
	onError?: (e: Error) => void
): Disposable {
	return commitMutation<useUpdateTicketingNotificationPrefsMutation>(environment, {
		mutation,
		variables: {
			input: {csrfToken: csrfToken(), socketClientId: socketClientId(), ...input},
		},
		onCompleted: onCompleted ? response => onCompleted(response) : undefined,
		onError: onError ? error => onError(error) : undefined,
	});
}

export default {commit, mutationId: 'useUpdateTicketingNotificationPrefsMutation'};
